import { ReactNode, useState } from "react"

// Dropdown that collapses into a dismissible chip (matching the user filter)
// once a value is picked — the chip both shows the active criterion and clears
// it on click, revealing the dropdown again. Renders its own popup listbox
// (instead of a native <select>) so options can carry icons/avatars.
export default function ChipSelect<T extends string>({ value, onChange, options, labels, icons, placeholder }: {
  value: "" | T
  onChange: (value: "" | T) => void
  options: T[]
  labels: Record<T, string>
  icons?: Partial<Record<T, ReactNode>>
  placeholder: string
}) {
  const [open, setOpen] = useState(false)

  if (value !== "") {
    return (
      <button className="skus-filter-chip skus-filter-chip-active icon-chip" onClick={() => onChange("")}>
        {icons?.[value]}
        {labels[value]} ✕
      </button>
    )
  }
  return (
    <div className="typeahead">
      <button
        className="filter-select chip-select-trigger"
        onClick={() => setOpen((prev) => !prev)}
        onBlur={() => setOpen(false)}
      >
        {placeholder}
        <span className="chip-select-caret" aria-hidden="true">▾</span>
      </button>
      {open && (
        <div className="typeahead-results chip-select-results">
          {options.map((option) => (
            // onMouseDown so selection wins over the trigger losing focus
            <button
              key={option}
              className="typeahead-result"
              onMouseDown={() => {
                onChange(option)
                setOpen(false)
              }}
            >
              {icons?.[option]}
              <span className="typeahead-result-text">{labels[option]}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
